import Cookies from "js-cookie/src/js.cookie";
Cookies.set('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
